// extracted by mini-css-extract-plugin
export default {"description":"case-draft-count-panel__description--XEifE"};